import React, { useState, useMemo, useEffect } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Button from "../../../../Elements/Button/Button.js";
import parse from "html-react-parser";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { getDynamicTextByKey } from "utils/getDynamicTextByKey.js";

const TrackerComponent = ({
  language,
  hideTracker = null,
  brandingColorExternal = null,
}) => {
  const [brandingColor, setBrandingColor] = useState(null);
  const [mailStatus, setMailStatus] = useState("");
  const [mailIdCheck, setMailIdCheck] = useState("");
  const { getLanguage } = useContent();
  const [fieldsTranslate, setFieldsTranslate] = useState([]);
  const backFunctionOrderTracker = () => {
    setMailStatus("");
    setMailIdCheck("");
  };
  //check status of mail shipping
  const checkStatus = async () => {
    const body = {
      MailId: mailIdCheck,
      Culture: language,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CheckShippingReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.Result === 0) {
        setMailStatus(response.data.MailStatus);
      } else {
        setMailStatus("errorCheck");
      }
    } else {
      setMailStatus("errorCheck");
    }
  };
  //get all dynamic form consts and render form
  const handleFetchInnerConsts = async (langText) => {
    const response = await apiRequest("Translations", "ReactGetConsts", {
      lang: langText ? langText : getLanguage(),
      suffix: "ordertracker",
    });
    if (response.status === "success") {
      setFieldsTranslate(response.data);
    }
  };

  useMemo(() => {
    handleFetchInnerConsts(language);
  }, [language]);

  useEffect(() => {
    if (brandingColorExternal) {
      setBrandingColor(brandingColorExternal);
    }
  }, [brandingColorExternal]);

  return (
    <div className={`tracker-container ${hideTracker ? "hide" : ""}`}>
      {fieldsTranslate && brandingColor && (
        <div className="order-status-container">
          <div
            className="left-color"
            style={{ backgroundColor: brandingColor }}
          ></div>
          {!mailStatus ? (
            <div className="order-tracker-input">
              <div className="order-tracker-label">
                <label for="order-tracker-input">
                  {parse(
                    getDynamicTextByKey(
                      "check-status-text-embedpage",
                      fieldsTranslate
                    )
                  )}
                </label>
              </div>
              <div className="div-input-container">
                <div className="div-input">
                  <input
                    id="order-tracker-input"
                    onChange={(e) => setMailIdCheck(e.target.value)}
                    value={mailIdCheck}
                    type="text"
                  />
                </div>

                <div className="btn-check-status">
                  <Button
                    style={{ backgroundColor: brandingColor }}
                    onClick={() => {
                      checkStatus();
                    }}
                  >
                    {getDynamicTextByKey(
                      "check-status-button-order-tracker",
                      fieldsTranslate
                    )}
                  </Button>
                </div>
              </div>
            </div>
          ) : mailStatus !== "errorCheck" ? (
            <>
              <div className="status-details">
                <h3>
                  {parse(
                    getDynamicTextByKey(
                      "order-tracker-status-embedpage",
                      fieldsTranslate
                    ).replace("#STATUS#", mailStatus)
                  )}
                </h3>
                <div className="btn-check-status back-status">
                  <Button
                    blank
                    style={{
                      color: brandingColor,
                      borderColor: brandingColor,
                    }}
                    onClick={() => {
                      backFunctionOrderTracker();
                    }}
                  >
                    {getDynamicTextByKey(
                      "back-text-order-tracker",
                      fieldsTranslate
                    )}
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="status-details">
                <h3>
                  {getDynamicTextByKey(
                    "order-tracker-not-found",
                    fieldsTranslate
                  )}
                </h3>
                <div className="btn-check-status back-status">
                  <Button
                    blank
                    style={{
                      color: brandingColor,
                      borderColor: brandingColor,
                    }}
                    onClick={() => {
                      setMailStatus("");
                    }}
                  >
                    {getDynamicTextByKey(
                      "try-again-order-tracker",
                      fieldsTranslate
                    )}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TrackerComponent;
